// Public "What's new" entries — newest first. Add a new entry at the top for each shipped batch.
export const CHANGELOG = [
  {
    date: "2026-10-16",
    title: "Season changelog, What's New strip & About refresh",
    tag: "Site",
    items: [
      "This page — every update by date so you can catch up anytime.",
      "One-time 'New this season' strip on the live map linking to the updated About page.",
      "About page gains Prescribed Burns & Fall Readiness and Learn & Install sections, plus refreshed data sources.",
    ],
  },
  {
    date: "2026-10-16",
    title: "Video walkthroughs in English & Español",
    tag: "Guide",
    items: [
      "5-minute desktop walkthrough: smoke checks, fires, and every notification Firewatch can send.",
      "2-minute phone tour: Map / Feed switch, Fires · DOT · More tabs, and install-to-home-screen on iPhone and Android.",
      "Spanish voice track and Spanish captions for both videos; the Guide auto-selects your browser language.",
      "Share menu under each video and downloadable Facebook clips (smoke checks, fires, notifications, phone tour).",
      "First-time phone visitors get the phone tour once, with a Skip button.",
    ],
  },
  {
    date: "2026-10-14",
    title: "Exact prescribed-burn units & Burning Today",
    tag: "Rx Burns",
    items: [
      "USFS FACTS planned burn-unit boundaries drawn as dashed purple polygons around active Rx burns.",
      "WA DNR permitted burns (Approved + Requested) on the map and in the Planned / Prescribed Burns card.",
      "'Burning Today' strip above the incident feed shows which permitted burns are lit right now.",
      "Heads-up push when DNR approves a burn inside your saved-location radius.",
    ],
  },
  {
    date: "2026-10-12",
    title: "Quiet Hours, mudflow reports & rain reality check",
    tag: "Alerts",
    items: [
      "Quiet Hours mute informational pushes overnight and sync across every device on your account — Level 3 GO evacuations and flood warnings always break through.",
      "One-tap 'Debris on road' pin for verified reporters, straight from GPS.",
      "Debris-flow risk is checked against real rainfall measured by USGS gauges before an alert escalates.",
      "Daily briefings: morning fire summary around 8 AM and evening recap around 8 PM.",
    ],
  },
  {
    date: "2026-10-10",
    title: "Sign in with Google",
    tag: "Accounts",
    items: [
      "Join or log in with one tap using your Google account — alongside classic email + password.",
      "Saved locations, follows, and quiet hours follow your account.",
    ],
  },
  {
    date: "2026-09-28",
    title: "Flood & debris-flow watch for burn scars",
    tag: "Fall Readiness",
    items: [
      "Burn scars with downstream debris-flow paths traced from USGS NLDI.",
      "Live USGS stream gauges on the map with spike alerts.",
      "NWS flood warnings pushed immediately to nearby saved locations.",
      "Season recap page summarizing the fire year.",
    ],
  },
  {
    date: "2026-08-20",
    title: "Live wind, rain radar, lightning & map tools",
    tag: "Map",
    items: [
      "Live Wind arrows from NWS stations and animated NEXRAD Rain Radar layers.",
      "Lightning strike layer with cluster pushes (3+ strikes near a saved location within 30 minutes).",
      "Map screenshot (watermarked, time-stamped) and a mile-by-mile measuring tape.",
      "Address / town search on every map; Info Pins with photos and links for staff and verified reporters.",
    ],
  },
  {
    date: "2026-07-25",
    title: "Follow fires, convergence & edge-approach alerts",
    tag: "Alerts",
    items: [
      "Follow any fire for live distance from your pin measured to the nearest perimeter edge.",
      "Rapid growth (2x in 24 h), edge approach (a mile or more closer), and convergence (two large fires merging) pushes.",
      "AI incident summaries, spread-direction analysis, and 'Is your place in the line of fire?'.",
      "Share My Status daily check-in card with QR code.",
    ],
  },
  {
    date: "2026-07-01",
    title: "Evacuations, road closures & aircraft",
    tag: "Core",
    items: [
      "Level 1 / 2 / 3 evacuation zones from county Emergency Management drawn live, with road closures inside each zone.",
      "WSDOT highway alerts and mountain pass conditions; County EM road closures.",
      "Live firefighting aircraft via ADS-B with photos and trails.",
      "Multi-region views: 13 counties, Washington statewide, and the BC border.",
    ],
  },
  {
    date: "2026-05-22",
    title: "Firewatch launches",
    tag: "Launch",
    items: [
      "Live WildCAD-E dispatch feed from 8 Washington dispatch centers on a tactical dark map.",
      "NIFC perimeters, NASA VIIRS satellite hotspots, NWS alerts, wildfire cameras, and historical heatmap.",
      "Saved locations with radius push alerts; verified reporter field updates.",
    ],
  },
];
